import type { FieldValidator } from '@aviv-estimation-funnel/data-validation/field-validator';
import { defaultRadioField } from '@mfe-presentation/constants/defaultFields';
import { EUIComponent, EStepComponent } from '@mfe-types/enum';
import { EErrorCode } from '@mfe-types/validator';
import {
    SaleMethod,
    OwnerObjective,
    WantsToSellOwnerObjectives,
} from '@aviv-estimation-funnel/estimation-data-models/enums';
import { getIsSeller } from '@mfe-helpers/formHelpers';
import { dv } from '@aviv-estimation-funnel/data-validation/dv';
import { IPortalConfiguration } from '@aviv-estimation-funnel/shells/src/app/types/config';
import { validatePhone } from '@mfe-services/phoneValidationApiRequests';
import { submitForm } from '@mfe-services/submitFormApiRequests';
import { SelectField, RadioBooleanField } from '@mfe-types/field';
import { IStep } from '@mfe-types/form';
import useSmsService from '@mfe-presentation/hooks/useSmsService';
import { TLocale } from '@aviv-estimation-funnel/shells/src/app/helpers/i18n';

import {
    getPropertyFields,
    generateStepsConfig,
    ICommonStepsConfiguration,
    getProfileFields,
} from '../common/commonStepsConfig';

export const getGermanProfileFields = (validators: Record<string, FieldValidator<unknown>>) => ({
    ...getProfileFields(validators)(),
    /* The test on field sale method is paused */
    /* saleMethod: {
        ...defaultRadioField,
        uiComponent: EUIComponent.Radio,
        // TODO: VEGA-1446 revert temporary frontend validation
        validators: dv
            .enum(SaleMethod)
            .if((fieldValues) => getIsSeller(fieldValues['ownerObjective'] as OwnerObjective)),
        displayErrorOnFocusOut: true,
        displayErrorImmediately: (errorType: EErrorCode) => errorType === EErrorCode.Required,
        options: {
            values: [
                { value: SaleMethod.OnTheirOwn },
                { value: SaleMethod.WithRealtors },
                { value: SaleMethod.DontKnowYet },
            ],
        },
        displayedConditions: [
            (fieldValues: Record<string, any>) => getIsSeller(fieldValues.ownerObjective),
        ],
    }, */
});

export interface IGermanStepConfiguration extends ICommonStepsConfiguration {
    update: {
        stepComponent: EStepComponent;
        getFields: () => {
            isPropertyOwner: RadioBooleanField;
            propertyMainUsage: SelectField;
            ownerObjective: SelectField;
            nonOwnerObjective: SelectField;
        };
        httpCalls: Record<string, (...args: any) => Promise<any>>;
        customSubmit: (
            fieldValues: Record<string, any>,
            config: IStep,
            name: string,
            locale: TLocale,
        ) => Promise<any>;
    };
}

export type IGermanFrontConfiguration = IPortalConfiguration<IGermanStepConfiguration>;

export const generateGermanStepsConfig = (
    validators: Record<string, FieldValidator<unknown>>,
    regularExpression: Record<string, RegExp>,
): IGermanStepConfiguration => {
    const commonConfig = generateStepsConfig(validators, regularExpression);
    return {
        ...commonConfig,
        profile: {
            ...commonConfig.profile,
            getFields: () => getGermanProfileFields(validators),
        },
        update: {
            stepComponent: EStepComponent.UpdateForm,
            getFields: getPropertyFields(validators),
            httpCalls: {
                validatePhone,
                submitForm,
            },
            customSubmit: useSmsService,
        },
    };
};
